import { render, staticRenderFns } from "./RegisterShadow.vue?vue&type=template&id=777a8870&lang=pug"
import script from "./RegisterShadow.vue?vue&type=script&lang=js"
export * from "./RegisterShadow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports